module.exports = __webpack_public_path__ + "static/img/file-bg.0f15196.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/file-bg.png
// module id = HvAG
// module chunks = 96